import Vue from "vue";
import Vant from "vant";
import "vant/lib/index.css";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
// import "@/components/element-#F46C6C/index.css";
import App from "./App";
import router from "./router";
import store from "./store";
// import "./permission"; // 权限
import Video from "video.js";
import "video.js/dist/video-js.css";
import VueParticles from "vue-particles";

Vue.prototype.$video = Video;
// 全局引入echarts
import echarts from "echarts";
// echarts地图扩展插件
import "echarts/extension/bmap/bmap";
import "echarts/map/js/china";
// d3.js
import * as d3 from "d3";
// 总线传值
import "./utils/eventBus";
// 公用方法
import utils from "./utils/utils";
// 公用方法
import pageUtils from "./utils/pageUtils";
// 全局过滤器
import * as filters from "./filters";
// 兼容性处理
import "babel-polyfill";
// error log
import "./components/ErrorLog/errorLog";
// 自定义指令
import "./directive/index";
// 时间相关方法
import dateFormat from "./utils/dateUtils";

//全局自定义组件
import "./commonComponents/common";
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";

import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/css/swiper.css";
// import "swiper/swiper-bundle.css";
// import Swiper from 'swiper';
// import 'swiper/swiper-bundle.css'

Vue.use(Viewer, {
  defaultOptions: {
    toolbar: false,
    zIndex: 9999
  }
});
Vue.use(VueParticles);
// 模拟数据 本地测试使用
// import './mock'

// import "../static/UE/ueditor.config.js";
// import "../static/UE/ueditor.all.min.js";
// import "../static/UE/lang/zh-cn/zh-cn.js";
// import "../static/UE/ueditor.parse.min.js";
// import "../static/UE/dialogs/xiumi-ue-dialog-v5.js";
// import "../static/UE/dialogs/xiumi-ue-v5.css";
// import "../static/UE/themes/iframe.css";

//过滤器统一处理加载
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});
Vue.use(utils);
Vue.use(pageUtils);
Vue.use(ElementUI);
Vue.use(Vant);
Vue.use(VueAwesomeSwiper);
// Vue.use(Swiper);
Vue.prototype.$echarts = echarts;
Vue.prototype.$dateFormat = dateFormat;
Vue.prototype.$d3 = d3;
Vue.config.productionTip = false;
new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js